
import FusionServicesClient from "client-fusion-integrations/src/index.js";
import WvusServicesClient from "wvus-services-client-integrations";
import appSettings from "../settings/appSettings";
import { setApiUrl } from "../helpers/helpers";

const { auth0Config, fusionConfig, ideaConfig, loginRedirectUrl } = appSettings;

export const servicesClient = new WvusServicesClient({
  auth0Config,
  ideaConfig
});

const fusion = new FusionServicesClient({
  baseUrl: setApiUrl(fusionConfig.baseUrl),
  auth0Config
});

if (!fusion.isInit){
  fusion.initSession().catch(() => null);
}

export const checkActiveSponsorship = async () => {
  try {
    const sponHistoryData = await getSponHistory();
    const activeCount = sponHistoryData?.ActiveChildrenCount;
    const inactiveCount = sponHistoryData?.InActiveChildrenCount;
    const firstSponItem = sponHistoryData?.ActiveChildren[0];
    const childGuid = firstSponItem?.ChildNumber;
    const EventChosenRevealed = firstSponItem?.EventChosenRevealed;
    const isChosen = firstSponItem?.IsChosen;

    const result = {
      activeCount: activeCount,
      inactiveCount: inactiveCount,
      childGuid: childGuid,
      EventChosenRevealed: EventChosenRevealed,
      isChosen: isChosen,
    };

    return result;
  } catch (err) {
    console.log("error", err);
    return null;
  }
};

export const hasSponsorship = async (childId) => {
  try {
    let found = false;
    const sponHistoryData = await getSponHistory();
    const children = sponHistoryData.ActiveChildren;
    //loop through active children to see if any match the child ID of the current MSC session
    function hasId(childId) {
      children.forEach((sponsorship) => {
        if (sponsorship.ChildNumber == childId) {
          found = true;
        }
      });
    }
    hasId(childId);
    return found;
  } catch (err) {
    // console.log(err);
    return null;
  }
};

export async function getSponHistory(params = {}) {
  try {
    const sponHistoryData = await fusion.sponHistory(params);
    return sponHistoryData;
  } catch (err) {
    // console.log(err);
    return Promise.reject(err);
  }
}

export async function isAuth() {
  return fusion.getSupporterNumber().then(supporterNumber => !!supporterNumber).catch(() => false);
}

export function getCommitmentByGuid(childIdGuid, retry = 0) {
  const retryRequest = (err) => {
    if (err.message.includes("__raw") && retry < 2) {
      return getCommitmentByGuid(childIdGuid, ++retry);
    }

    return Promise.reject(err);
  };

  return servicesClient
    .readCommitmentByChildNumber(childIdGuid, {childNumberType: "guid"})
      .catch(retryRequest);
}
